"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountEventContract = exports.DiscountEventDataContract = exports.DiscountEventBrand = exports.DiscountEventCategory = exports.DiscountEventProduct = exports.CartDiscountLine = exports.CreateOrEditDiscount = exports.DiscountBrand = exports.DiscountCategory = exports.DiscountProduct = exports.ApplyTypes = exports.SalesChannels = exports.LoyaltyDiscountType = exports.DiscountModes = exports.DiscountTypes = void 0;
const homi_shared_1 = require("@getgreenline/homi-shared");
const mobx_1 = require("mobx");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const events_1 = require("@getgreenline/events");
var DiscountTypes;
(function (DiscountTypes) {
    DiscountTypes["FIXED"] = "fixed";
    DiscountTypes["PERCENT"] = "percent";
})(DiscountTypes || (exports.DiscountTypes = DiscountTypes = {}));
var DiscountModes;
(function (DiscountModes) {
    DiscountModes[DiscountModes["ALL_PRODUCTS_AND_CATEGORIES"] = 0] = "ALL_PRODUCTS_AND_CATEGORIES";
    DiscountModes[DiscountModes["SPECIFIC_PRODUCTS"] = 1] = "SPECIFIC_PRODUCTS";
    DiscountModes[DiscountModes["SPECIFIC_CATEGORIES"] = 2] = "SPECIFIC_CATEGORIES";
    DiscountModes[DiscountModes["NO_DISCOUNT"] = 3] = "NO_DISCOUNT";
})(DiscountModes || (exports.DiscountModes = DiscountModes = {}));
var LoyaltyDiscountType;
(function (LoyaltyDiscountType) {
    LoyaltyDiscountType["LOYALTY_TIER"] = "loyaltyTier";
    LoyaltyDiscountType["LOYALTY_POINT"] = "loyaltyPoint";
})(LoyaltyDiscountType || (exports.LoyaltyDiscountType = LoyaltyDiscountType = {}));
exports.SalesChannels = {
    ANY: { id: 0, name: 'all', displayName: 'All' },
    POS: { id: 1, name: 'pos', displayName: 'POS' },
    ECOM: { id: 2, name: 'ecommerce', displayName: 'Ecommerce' },
    KIOSK: { id: 3, name: 'kiosk', displayName: 'Kiosk' },
    MOBILE: { id: 4, name: 'mobile', displayName: 'Mobile' },
};
var ApplyTypes;
(function (ApplyTypes) {
    ApplyTypes["CART"] = "cart";
    ApplyTypes["PRODUCTS"] = "products";
    ApplyTypes["BUNDLE"] = "bundle";
})(ApplyTypes || (exports.ApplyTypes = ApplyTypes = {}));
class DiscountProduct {
    constructor() {
        this.type = 'include';
    }
}
exports.DiscountProduct = DiscountProduct;
__decorate([
    mobx_1.observable
], DiscountProduct.prototype, "id", void 0);
__decorate([
    mobx_1.observable
], DiscountProduct.prototype, "type", void 0);
__decorate([
    mobx_1.observable
], DiscountProduct.prototype, "name", void 0);
__decorate([
    mobx_1.observable
], DiscountProduct.prototype, "parentProductId", void 0);
class DiscountCategory {
    constructor() {
        this.type = 'include';
    }
}
exports.DiscountCategory = DiscountCategory;
__decorate([
    mobx_1.observable
], DiscountCategory.prototype, "id", void 0);
__decorate([
    mobx_1.observable
], DiscountCategory.prototype, "type", void 0);
__decorate([
    mobx_1.observable
], DiscountCategory.prototype, "name", void 0);
__decorate([
    mobx_1.observable
], DiscountCategory.prototype, "parentCategoryId", void 0);
__decorate([
    mobx_1.observable
], DiscountCategory.prototype, "colorHex", void 0);
class DiscountBrand {
    constructor() {
        this.type = 'include';
    }
}
exports.DiscountBrand = DiscountBrand;
__decorate([
    mobx_1.observable
], DiscountBrand.prototype, "id", void 0);
__decorate([
    mobx_1.observable
], DiscountBrand.prototype, "type", void 0);
__decorate([
    mobx_1.observable
], DiscountBrand.prototype, "name", void 0);
class CreateOrEditDiscount {
    setLoyaltyTierId(id) {
        this.loyaltyTierId = id;
    }
    constructor(discount) {
        this.name = '';
        this.description = '';
        this.type = DiscountTypes.PERCENT;
        this.applyType = 'products';
        this.amount = 0;
        this.loyaltyTierId = null;
        this.locationIds = [];
        this.products = [];
        this.categories = [];
        this.brands = [];
        this.loyaltyCost = 0;
        this.salesChannels = [];
        this.setName = (name) => {
            this.name = name;
        };
        this.setDescription = (description) => {
            this.description = description;
        };
        this.setApplyType = (applyType) => {
            this.applyType = applyType;
        };
        this.setAutomaticDiscount = (bool) => {
            this.automatic = bool;
        };
        this.setIsLoyaltyDiscount = (isLoyalty) => {
            this.isLoyalty = isLoyalty;
        };
        this.setSalesChannels = (salesChannels) => {
            this.salesChannels = salesChannels;
        };
        this.setLoyaltyCost = (loyaltyCost) => {
            this.loyaltyCost = loyaltyCost;
        };
        this.setLoyaltyTiers = (loyaltyTiers) => {
            this.loyaltyTiers = loyaltyTiers;
        };
        this.setIsStackable = (isStackable) => {
            this.isStackable = isStackable;
        };
        this.set(discount);
    }
    set(discount) {
        if (discount) {
            Object.assign(this, discount);
            this.products = this.products.map((p) => {
                return Object.assign(new DiscountProduct(), p);
            });
            this.categories = this.categories.map((c) => {
                return Object.assign(new DiscountCategory(), c);
            });
            this.brands = this.brands.map((s) => Object.assign(new DiscountBrand(), s));
        }
    }
    addProductWithData(data) {
        this.products = [...this.products, data];
    }
    removeProduct(index) {
        this.products.splice(index, 1);
    }
    addCategoryWithData(data) {
        this.categories = [...this.categories, data];
    }
    removeCategory(index) {
        this.categories.splice(index, 1);
    }
    setLocationIds(ids) {
        this.locationIds = ids;
    }
    toggleApplyDateRestriction() {
        this.applyDateRestriction = !this.applyDateRestriction;
        this.toggleIsRecurring();
        this.isRecurring = false;
        this.startTime = null;
        this.endTime = null;
    }
    toggleIsRecurring() {
        this.isRecurring = !this.isRecurring;
        this.sunday = false;
        this.monday = false;
        this.tuesday = false;
        this.wednesday = false;
        this.thursday = false;
        this.friday = false;
        this.saturday = false;
        this.startDate = null;
        this.endDate = null;
    }
    sanitize() {
        const sanitizedProducts = this.products.filter((product) => product.id);
        const sanitizedCategories = this.categories.filter((category) => category.id);
        this.products = sanitizedProducts;
        this.categories = sanitizedCategories;
    }
    removeAllCategories() {
        this.categories = [];
    }
    removeAllProducts() {
        this.products = [];
    }
    get isValid() {
        let valid = true;
        if (!this.name) {
            valid = false;
        }
        this.products.forEach((p) => {
            if (!p.id) {
                valid = false;
            }
        });
        this.categories.forEach((c) => {
            if (!c.id) {
                valid = false;
            }
        });
        return valid;
    }
}
exports.CreateOrEditDiscount = CreateOrEditDiscount;
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "id", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "name", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "description", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "companyId", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "type", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "applyType", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "amount", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "loyaltyTierId", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "locationIds", void 0);
__decorate([
    mobx_1.action
], CreateOrEditDiscount.prototype, "setLoyaltyTierId", null);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "products", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "categories", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "brands", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "applyDateRestriction", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "isRecurring", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "sunday", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "monday", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "tuesday", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "wednesday", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "thursday", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "friday", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "saturday", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "startDate", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "endDate", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "startTime", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "endTime", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "automatic", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "isLoyalty", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "loyaltyCost", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "discountCode", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "salesChannels", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "loyaltyTiers", void 0);
__decorate([
    mobx_1.observable
], CreateOrEditDiscount.prototype, "isStackable", void 0);
__decorate([
    mobx_1.action
], CreateOrEditDiscount.prototype, "setName", void 0);
__decorate([
    mobx_1.action
], CreateOrEditDiscount.prototype, "setDescription", void 0);
__decorate([
    mobx_1.action
], CreateOrEditDiscount.prototype, "setApplyType", void 0);
__decorate([
    mobx_1.action
], CreateOrEditDiscount.prototype, "setAutomaticDiscount", void 0);
__decorate([
    mobx_1.action
], CreateOrEditDiscount.prototype, "setIsLoyaltyDiscount", void 0);
__decorate([
    mobx_1.action
], CreateOrEditDiscount.prototype, "setSalesChannels", void 0);
__decorate([
    mobx_1.action
], CreateOrEditDiscount.prototype, "addProductWithData", null);
__decorate([
    mobx_1.action
], CreateOrEditDiscount.prototype, "removeProduct", null);
__decorate([
    mobx_1.action
], CreateOrEditDiscount.prototype, "addCategoryWithData", null);
__decorate([
    mobx_1.action
], CreateOrEditDiscount.prototype, "removeCategory", null);
__decorate([
    mobx_1.action
], CreateOrEditDiscount.prototype, "setLocationIds", null);
__decorate([
    mobx_1.action
], CreateOrEditDiscount.prototype, "toggleApplyDateRestriction", null);
__decorate([
    mobx_1.action
], CreateOrEditDiscount.prototype, "toggleIsRecurring", null);
__decorate([
    mobx_1.action
], CreateOrEditDiscount.prototype, "sanitize", null);
__decorate([
    mobx_1.action
], CreateOrEditDiscount.prototype, "removeAllCategories", null);
__decorate([
    mobx_1.action
], CreateOrEditDiscount.prototype, "removeAllProducts", null);
__decorate([
    mobx_1.action
], CreateOrEditDiscount.prototype, "setLoyaltyCost", void 0);
__decorate([
    mobx_1.action
], CreateOrEditDiscount.prototype, "setLoyaltyTiers", void 0);
__decorate([
    mobx_1.action
], CreateOrEditDiscount.prototype, "setIsStackable", void 0);
__decorate([
    mobx_1.computed
], CreateOrEditDiscount.prototype, "isValid", null);
class CartDiscountLine {
    constructor(cartDiscountLine) {
        this.type = homi_shared_1.PaymentLineType.DISCOUNT;
        this.discountId = null;
        this.setPaymentLines = (paymentLines) => {
            this.paymentLines = paymentLines;
        };
        this.setDiscountPrice = (discountPrice) => {
            this.discountPrice = discountPrice;
        };
        this.shouldBeExcluded = (productId, categoryId) => {
            /**
             * Examine whether a cart discount is subject to product and category IDs to be excluded
             */
            if (productId === null)
                return true; // i.e. discount line
            const shouldExcludeProductId = this.excludeProductIds.includes(productId);
            const shouldExcludeCategoryId = categoryId === null ? false : this.excludeCategoryIds.includes(categoryId);
            return shouldExcludeProductId || shouldExcludeCategoryId;
        };
        this.shouldBeTargeted = (productId, categoryId) => {
            /**
             * This examines whether `productId` or `categoryId` are specifically targeted by a cart discount
             */
            if (productId === null)
                return false; // i.e. discount line
            const productIdTargeted = this.targetedProductIds.includes(productId);
            const categoryIdTargeted = categoryId === null ? false : this.targetedCategoryIds.includes(categoryId);
            return productIdTargeted || categoryIdTargeted;
        };
        this.paymentLines = cartDiscountLine.paymentLines;
        this.productName = cartDiscountLine.productName;
        this.discountType = cartDiscountLine.discountType;
        this.discountId = cartDiscountLine.discountId;
        this.originalDiscountPrice = Math.abs(cartDiscountLine.originalDiscountPrice) * -1;
        this.discountPrice = Math.abs(cartDiscountLine.discountPrice) * -1;
        this.discountPercentage = cartDiscountLine.discountPercentage;
        this.referenceDiscount = cartDiscountLine.referenceDiscount;
    }
    get isTargetedCartDiscount() {
        return this.targetedProductIds.length > 0 || this.targetedCategoryIds.length > 0;
    }
    get networkTransferObject() {
        return {
            type: this.type,
            productId: null,
            productName: this.productName,
            units: 1,
            unit: 'unit',
            inventorySubtracted: 1,
            price: 0,
            depositFee: null,
            discountId: this.discountId,
            discountPrice: Math.round(this.discountPrice),
            discountMessage: null,
            cartDiscountPrice: 0,
            barcode: null,
            shortDescription: null,
            batchId: null,
            sku: null,
        };
    }
    get excludedPaymentLines() {
        return this.paymentLines.filter((pl) => {
            return pl.type === homi_shared_1.PaymentLineType.LOYALTY
                ? false
                : this.shouldBeExcluded(pl.productId, pl.categoryId);
        });
    }
    get targetedPaymentLines() {
        return this.paymentLines.filter((pl) => {
            return pl.type === homi_shared_1.PaymentLineType.LOYALTY
                ? false
                : this.shouldBeTargeted(pl.productId, pl.categoryId);
        });
    }
    get includedPaymentLines() {
        if (this.isTargetedCartDiscount) {
            return this.targetedPaymentLines;
        }
        return this.paymentLines.filter((pl) => {
            return pl.type === homi_shared_1.PaymentLineType.LOYALTY
                ? false
                : !this.shouldBeExcluded(pl.productId, pl.categoryId);
        });
    }
    get excludeProductIds() {
        return this.referenceDiscount === undefined
            ? []
            : this.referenceDiscount.products.filter((pcl) => pcl.type === 'exclude').map((pcl) => pcl.id);
    }
    get excludeCategoryIds() {
        return this.referenceDiscount === undefined
            ? []
            : this.referenceDiscount.categories
                .filter((pcl) => pcl.type === 'exclude')
                .map((pcl) => pcl.id);
    }
    get targetedProductIds() {
        return this.referenceDiscount === undefined
            ? []
            : this.referenceDiscount.products.filter((pcl) => pcl.type === 'include').map((pcl) => pcl.id);
    }
    get targetedCategoryIds() {
        return this.referenceDiscount === undefined
            ? []
            : this.referenceDiscount.categories
                .filter((pcl) => pcl.type === 'include')
                .map((pcl) => pcl.id);
    }
    // Currently we only support 3 discount modes
    get discountMode() {
        if ((this.excludeProductIds.length >= 0 || this.excludeCategoryIds.length >= 0) &&
            this.targetedProductIds.length === 0 &&
            this.targetedCategoryIds.length === 0) {
            return DiscountModes.ALL_PRODUCTS_AND_CATEGORIES;
        }
        if (this.excludeProductIds.length === 0 &&
            this.excludeCategoryIds.length === 0 &&
            this.targetedProductIds.length > 0 &&
            this.targetedCategoryIds.length === 0) {
            return DiscountModes.SPECIFIC_PRODUCTS;
        }
        if ((this.excludeProductIds.length >= 0 || this.excludeCategoryIds.length >= 0) &&
            this.targetedProductIds.length === 0 &&
            this.targetedCategoryIds.length > 0) {
            return DiscountModes.SPECIFIC_CATEGORIES;
        }
        return DiscountModes.NO_DISCOUNT; // This shouldn't happen
    }
}
exports.CartDiscountLine = CartDiscountLine;
__decorate([
    mobx_1.observable
], CartDiscountLine.prototype, "paymentLines", void 0);
__decorate([
    mobx_1.observable
], CartDiscountLine.prototype, "discountPrice", void 0);
__decorate([
    mobx_1.observable
], CartDiscountLine.prototype, "discountPercentage", void 0);
__decorate([
    mobx_1.action
], CartDiscountLine.prototype, "setPaymentLines", void 0);
__decorate([
    mobx_1.action
], CartDiscountLine.prototype, "setDiscountPrice", void 0);
__decorate([
    mobx_1.computed
], CartDiscountLine.prototype, "isTargetedCartDiscount", null);
__decorate([
    mobx_1.computed
], CartDiscountLine.prototype, "networkTransferObject", null);
__decorate([
    mobx_1.computed
], CartDiscountLine.prototype, "excludedPaymentLines", null);
__decorate([
    mobx_1.computed
], CartDiscountLine.prototype, "targetedPaymentLines", null);
__decorate([
    mobx_1.computed
], CartDiscountLine.prototype, "includedPaymentLines", null);
__decorate([
    mobx_1.computed
], CartDiscountLine.prototype, "excludeProductIds", null);
__decorate([
    mobx_1.computed
], CartDiscountLine.prototype, "excludeCategoryIds", null);
__decorate([
    mobx_1.computed
], CartDiscountLine.prototype, "targetedProductIds", null);
__decorate([
    mobx_1.computed
], CartDiscountLine.prototype, "targetedCategoryIds", null);
__decorate([
    mobx_1.computed
], CartDiscountLine.prototype, "discountMode", null);
class DiscountEventProduct {
}
exports.DiscountEventProduct = DiscountEventProduct;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], DiscountEventProduct.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], DiscountEventProduct.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], DiscountEventProduct.prototype, "parentProductId", void 0);
class DiscountEventCategory {
}
exports.DiscountEventCategory = DiscountEventCategory;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], DiscountEventCategory.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], DiscountEventCategory.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], DiscountEventCategory.prototype, "parentCategoryId", void 0);
class DiscountEventBrand {
}
exports.DiscountEventBrand = DiscountEventBrand;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)()
], DiscountEventBrand.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], DiscountEventBrand.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], DiscountEventBrand.prototype, "type", void 0);
class DiscountEventDataContract {
}
exports.DiscountEventDataContract = DiscountEventDataContract;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "locationIds", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "applyType", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "amount", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "loyaltyTierId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "loyaltyTierName", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "products", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "categories", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "brands", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "applyDateRestriction", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "isRecurring", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "sunday", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "monday", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "tuesday", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "wednesday", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "thursday", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "friday", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "saturday", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "startDate", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "endDate", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "startTime", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "endTime", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "automatic", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "isLoyalty", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "isDeleted", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "updateDate", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "loyaltyCost", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "discountCode", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "salesChannels", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "loyaltyTiers", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)()
], DiscountEventDataContract.prototype, "isStackable", void 0);
class DiscountEventContract extends events_1.EventContract {
    constructor(params) {
        super(params);
        this.discount = events_1.GreenlineEvent.create(DiscountEventDataContract, params.discount);
    }
}
exports.DiscountEventContract = DiscountEventContract;
//# sourceMappingURL=discount.js.map